// @flow
import * as React from "react";
import { Message, Select } from "semantic-ui-react";
import { connect } from "react-redux";

import { GoogleTagManager } from "../../../Utilities";
import { mapLocations } from "Commons/Components/FormComponents/misc/Mappers";
import Styles from "./LocationSelect.module.scss";
import type { PropsSelectT } from "./Types";

let MyProfileSelectableDynamic = class MyProfileSelectableDynamic extends React.Component<PropsSelectT> {
  static defaultProps = {
    profile: true,
  };

  handleChange = (value: ?number) => {
    const { options, change } = this.props;
    const location = options.find((location) => location.value === value);
    if (location) {
      change("location", location.text);
      change("locationId", location.value);
      change("locationMainName", location.mainname);
      change("locationPartName", location.partname);
    }
  };

  componentDidUpdate(prevProps) {
    const { options, launchEvent } = this.props;
    if (options && options.length === 1 && prevProps.options[0].value !== options[0].value) {
      this.handleChange(options[0].value);
      if (launchEvent) {
        GoogleTagManager.locationGiven();
      }
    }
  }

  render() {
    const { name, meta, input, isLoading, options, launchEvent, t, profile, showHint } = this.props;
    let finalOptions = [];
    let { error, touched } = meta;

    finalOptions = options;

    return (
      <>
        {showHint && options && options.length > 1 && (
          <div className={"hint"}>{t("formFieldDescriptors.location.hint")}</div>
        )}
        <div style={{ paddingBottom: "1rem" }}>
          <Select
            lazyLoad
            className={profile ? Styles["city"] : null}
            data-cy={"locationId-select"}
            name={name}
            style={{ minWidth: "7em" }}
            icon={finalOptions && finalOptions.length > 1 ? undefined : null}
            disabled={finalOptions && finalOptions.length > 1 ? undefined : true}
            label={name}
            placeholder={t("formFieldDescriptors.location.placeholder")}
            error={!!error && touched}
            loading={isLoading}
            onChange={(_, { value }) => {
              if (launchEvent) {
                GoogleTagManager.locationGiven();
              }
              this.handleChange(value);
            }}
            options={finalOptions}
            value={input.value}
          />
          {error && touched && (
            <Message className={"profile-input"} style={{ marginTop: "1rem" }} negative content={meta.error} />
          )}
        </div>
      </>
    );
  }
};

const mapStatetoProps = ({ user: { user }, locations: { locations, isFetching } }, props) => {
  const {
    categorySlug,
    postalCode,
    meta: { form },
  } = props;

  const profileForm = user !== null && form === "profile";

  let options = profileForm
    ? [
        {
          name: user.location,
          id: user.locationId,
          mainName: user.location,
          partName: user.location,
        },
      ]
    : [
        {
          name: null,
          id: null,
          mainName: null,
          partName: null,
        },
      ];

  if (locations) {
    const byCategory = locations[categorySlug];
    if (byCategory) {
      const byPostalCode = byCategory[postalCode];
      if (byPostalCode) {
        options = byPostalCode;
      }
    }
  }

  return {
    options: options.map(mapLocations),
    isLoading: profileForm ? isFetching : null,
  };
};

MyProfileSelectableDynamic = connect(mapStatetoProps)(MyProfileSelectableDynamic);

let LocationSelect = MyProfileSelectableDynamic;

export default LocationSelect;
